import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { DefaultDataServiceConfig, HttpUrlGenerator, QueryParams } from '@ngrx/data';
import { Store } from '@ngrx/store';
import { LoggingService } from '../../shared/services/logging/logging.service';
import { EfaactDataService } from '../efaact.data-service';
import { CumulativeUpload } from './cumulative-upload.model';
import { tap } from 'rxjs/operators';
import { Observable } from 'rxjs';
import { DisplayMessageMinimum } from '../../common';
import * as fromShared from '../../shared';

export const entityName = 'CumulativeUpload';

@Injectable()
export class CumulativeUploadDataService extends EfaactDataService<CumulativeUpload> {
    constructor(
        http: HttpClient,
        httpUrlGenerator: HttpUrlGenerator,
        log: LoggingService,
        config: DefaultDataServiceConfig,
        store: Store
    ) {
        super(http, httpUrlGenerator, entityName, log, config, store);
    }

    getWithQuery(params: string | QueryParams): Observable<CumulativeUpload[]> {
        this.log.verbose({
            type: `${this.entityName}DataService(EfaactDataService):getWithQuery`,
            params
        });
        const result = this.getWithQueryPOST(params);
        return result.pipe(
            tap(items =>
                this.store.dispatch(
                    new fromShared.Errors.SetErrors(
                        [
                            ...items
                                .filter(
                                    l =>
                                        l &&
                                        l.Status &&
                                        l.Status.StatusCode >=
                                            DisplayMessageMinimum
                                )
                                .map(l => l.Status)
                        ].filter(fromShared.Errors.filterErrors)
                    )
                )
            )
        );
    }

    mapItems(item: CumulativeUpload): CumulativeUpload {
        if (!item) {
            return;
        }
        return {
            ...item
        };
    }
}
